/* tslint:disable */
export const ACTIVITY = 'activity';
export const AIRPLAY = 'airplay';
export const ALERT_CIRCLE = 'alert-circle';
export const ALERT_OCTAGON = 'alert-octagon';
export const ALERT_TRIANGLE = 'alert-triangle';
export const ALIGN_CENTER = 'align-center';
export const ALIGN_JUSTIFY = 'align-justify';
export const ALIGN_LEFT = 'align-left';
export const ALIGN_RIGHT = 'align-right';
export const ANCHOR = 'anchor';
export const APERTURE = 'aperture';
export const ARCHIVE = 'archive';
export const ARROW_DOWN_CIRCLE = 'arrow-down-circle';
export const ARROW_DOWN_LEFT = 'arrow-down-left';
export const ARROW_DOWN_RIGHT = 'arrow-down-right';
export const ARROW_DOWN = 'arrow-down';
export const ARROW_LEFT_CIRCLE = 'arrow-left-circle';
export const ARROW_LEFT = 'arrow-left';
export const ARROW_RIGHT_CIRCLE = 'arrow-right-circle';
export const ARROW_RIGHT = 'arrow-right';
export const ARROW_UP_CIRCLE = 'arrow-up-circle';
export const ARROW_UP_LEFT = 'arrow-up-left';
export const ARROW_UP_RIGHT = 'arrow-up-right';
export const ARROW_UP = 'arrow-up';
export const AT_SIGN = 'at-sign';
export const AWARD = 'award';
export const BAR_CHART_2 = 'bar-chart-2';
export const BAR_CHART = 'bar-chart';
export const BATTERY_CHARGING = 'battery-charging';
export const BATTERY = 'battery';
export const BELL_OFF = 'bell-off';
export const BELL = 'bell';
export const BLUETOOTH = 'bluetooth';
export const BOLD = 'bold';
export const BOOK_OPEN = 'book-open';
export const BOOK = 'book';
export const BOOKMARK = 'bookmark';
export const BOX = 'box';
export const BRIEFCASE = 'briefcase';
export const CALENDAR = 'calendar';
export const CAMERA_OFF = 'camera-off';
export const CAMERA = 'camera';
export const CAST = 'cast';
export const CHECK_CIRCLE = 'check-circle';
export const CHECK_SQUARE = 'check-square';
export const CHECK = 'check';
export const CHEVRON_DOWN = 'chevron-down';
export const CHEVRON_LEFT = 'chevron-left';
export const CHEVRON_RIGHT = 'chevron-right';
export const CHEVRON_UP = 'chevron-up';
export const CHEVRONS_DOWN = 'chevrons-down';
export const CHEVRONS_LEFT = 'chevrons-left';
export const CHEVRONS_RIGHT = 'chevrons-right';
export const CHEVRONS_UP = 'chevrons-up';
export const CHROME = 'chrome';
export const CIRCLE = 'circle';
export const CLIPBOARD = 'clipboard';
export const CLOCK = 'clock';
export const CLOUD_DRIZZLE = 'cloud-drizzle';
export const CLOUD_LIGHTNING = 'cloud-lightning';
export const CLOUD_OFF = 'cloud-off';
export const CLOUD_RAIN = 'cloud-rain';
export const CLOUD_SNOW = 'cloud-snow';
export const CLOUD = 'cloud';
export const CODE = 'code';
export const CODEPEN = 'codepen';
export const CODESANDBOX = 'codesandbox';
export const COFFEE = 'coffee';
export const COLUMNS = 'columns';
export const COMMAND = 'command';
export const COMPASS = 'compass';
export const COPY = 'copy';
export const CORNER_DOWN_LEFT = 'corner-down-left';
export const CORNER_DOWN_RIGHT = 'corner-down-right';
export const CORNER_LEFT_DOWN = 'corner-left-down';
export const CORNER_LEFT_UP = 'corner-left-up';
export const CORNER_RIGHT_DOWN = 'corner-right-down';
export const CORNER_RIGHT_UP = 'corner-right-up';
export const CORNER_UP_LEFT = 'corner-up-left';
export const CORNER_UP_RIGHT = 'corner-up-right';
export const CPU = 'cpu';
export const CREDIT_CARD = 'credit-card';
export const CROP = 'crop';
export const CROSSHAIR = 'crosshair';
export const DATABASE = 'database';
export const DELETE = 'delete';
export const DISC = 'disc';
export const DIVIDE_CIRCLE = 'divide-circle';
export const DIVIDE_SQUARE = 'divide-square';
export const DIVIDE = 'divide';
export const DOLLAR_SIGN = 'dollar-sign';
export const DOWNLOAD_CLOUD = 'download-cloud';
export const DOWNLOAD = 'download';
export const DRIBBBLE = 'dribbble';
export const DROPLET = 'droplet';
export const EDIT_2 = 'edit-2';
export const EDIT_3 = 'edit-3';
export const EDIT = 'edit';
export const EXTERNAL_LINK = 'external-link';
export const EYE_OFF = 'eye-off';
export const EYE = 'eye';
export const FACEBOOK = 'facebook';
export const FAST_FORWARD = 'fast-forward';
export const FEATHER = 'feather';
export const FIGMA = 'figma';
export const FILE_MINUS = 'file-minus';
export const FILE_PLUS = 'file-plus';
export const FILE_TEXT = 'file-text';
export const FILE = 'file';
export const FILM = 'film';
export const FILTER = 'filter';
export const FLAG = 'flag';
export const FOLDER_MINUS = 'folder-minus';
export const FOLDER_PLUS = 'folder-plus';
export const FOLDER = 'folder';
export const FRAMER = 'framer';
export const FROWN = 'frown';
export const GIFT = 'gift';
export const GIT_BRANCH = 'git-branch';
export const GIT_COMMIT = 'git-commit';
export const GIT_MERGE = 'git-merge';
export const GIT_PULL_REQUEST = 'git-pull-request';
export const GITHUB = 'github';
export const GITLAB = 'gitlab';
export const GLOBE = 'globe';
export const GRID = 'grid';
export const HARD_DRIVE = 'hard-drive';
export const HASH = 'hash';
export const HEADPHONES = 'headphones';
export const HEART = 'heart';
export const HELP_CIRCLE = 'help-circle';
export const HEXAGON = 'hexagon';
export const HOME = 'home';
export const IMAGE = 'image';
export const INBOX = 'inbox';
export const INFO = 'info';
export const INSTAGRAM = 'instagram';
export const ITALIC = 'italic';
export const KEY = 'key';
export const LAYERS = 'layers';
export const LAYOUT = 'layout';
export const LIFE_BUOY = 'life-buoy';
export const LINK_2 = 'link-2';
export const LINK = 'link';
export const LINKEDIN = 'linkedin';
export const LIST = 'list';
export const LOADER = 'loader';
export const LOCK = 'lock';
export const LOG_IN = 'log-in';
export const LOG_OUT = 'log-out';
export const MAIL = 'mail';
export const MAP_PIN = 'map-pin';
export const MAP = 'map';
export const MAXIMIZE_2 = 'maximize-2';
export const MAXIMIZE = 'maximize';
export const MEH = 'meh';
export const MENU = 'menu';
export const MESSAGE_CIRCLE = 'message-circle';
export const MESSAGE_SQUARE = 'message-square';
export const MIC_OFF = 'mic-off';
export const MIC = 'mic';
export const MINIMIZE_2 = 'minimize-2';
export const MINIMIZE = 'minimize';
export const MINUS_CIRCLE = 'minus-circle';
export const MINUS_SQUARE = 'minus-square';
export const MINUS = 'minus';
export const MONITOR = 'monitor';
export const MOON = 'moon';
export const MORE_HORIZONTAL = 'more-horizontal';
export const MORE_VERTICAL = 'more-vertical';
export const MOUSE_POINTER = 'mouse-pointer';
export const MOVE = 'move';
export const MUSIC = 'music';
export const NAVIGATION_2 = 'navigation-2';
export const NAVIGATION = 'navigation';
export const OCTAGON = 'octagon';
export const PACKAGE = 'package';
export const PAPERCLIP = 'paperclip';
export const PAUSE_CIRCLE = 'pause-circle';
export const PAUSE = 'pause';
export const PEN_TOOL = 'pen-tool';
export const PERCENT = 'percent';
export const PHONE_CALL = 'phone-call';
export const PHONE_FORWARDED = 'phone-forwarded';
export const PHONE_INCOMING = 'phone-incoming';
export const PHONE_MISSED = 'phone-missed';
export const PHONE_OFF = 'phone-off';
export const PHONE_OUTGOING = 'phone-outgoing';
export const PHONE = 'phone';
export const PIE_CHART = 'pie-chart';
export const PLAY_CIRCLE = 'play-circle';
export const PLAY = 'play';
export const PLUS_CIRCLE = 'plus-circle';
export const PLUS_SQUARE = 'plus-square';
export const PLUS = 'plus';
export const POCKET = 'pocket';
export const POWER = 'power';
export const PRINTER = 'printer';
export const RADIO = 'radio';
export const REFRESH_CCW = 'refresh-ccw';
export const REFRESH_CW = 'refresh-cw';
export const REPEAT = 'repeat';
export const REWIND = 'rewind';
export const ROTATE_CCW = 'rotate-ccw';
export const ROTATE_CW = 'rotate-cw';
export const RSS = 'rss';
export const SAVE = 'save';
export const SCISSORS = 'scissors';
export const SEARCH = 'search';
export const SEND = 'send';
export const SERVER = 'server';
export const SETTINGS = 'settings';
export const SHARE_2 = 'share-2';
export const SHARE = 'share';
export const SHIELD_OFF = 'shield-off';
export const SHIELD = 'shield';
export const SHOPPING_BAG = 'shopping-bag';
export const SHOPPING_CART = 'shopping-cart';
export const SHUFFLE = 'shuffle';
export const SIDEBAR = 'sidebar';
export const SKIP_BACK = 'skip-back';
export const SKIP_FORWARD = 'skip-forward';
export const SLACK = 'slack';
export const SLASH = 'slash';
export const SLIDERS = 'sliders';
export const SMARTPHONE = 'smartphone';
export const SMILE = 'smile';
export const SPEAKER = 'speaker';
export const SQUARE = 'square';
export const STAR = 'star';
export const STOP_CIRCLE = 'stop-circle';
export const SUN = 'sun';
export const SUNRISE = 'sunrise';
export const SUNSET = 'sunset';
export const TABLET = 'tablet';
export const TAG = 'tag';
export const TARGET = 'target';
export const TERMINAL = 'terminal';
export const THERMOMETER = 'thermometer';
export const THUMBS_DOWN = 'thumbs-down';
export const THUMBS_UP = 'thumbs-up';
export const TOGGLE_LEFT = 'toggle-left';
export const TOGGLE_RIGHT = 'toggle-right';
export const TOOL = 'tool';
export const TRASH_2 = 'trash-2';
export const TRASH = 'trash';
export const TRELLO = 'trello';
export const TRENDING_DOWN = 'trending-down';
export const TRENDING_UP = 'trending-up';
export const TRIANGLE = 'triangle';
export const TRUCK = 'truck';
export const TV = 'tv';
export const TWITCH = 'twitch';
export const TWITTER = 'twitter';
export const TYPE = 'type';
export const UMBRELLA = 'umbrella';
export const UNDERLINE = 'underline';
export const UNLOCK = 'unlock';
export const UPLOAD_CLOUD = 'upload-cloud';
export const UPLOAD = 'upload';
export const USER_CHECK = 'user-check';
export const USER_MINUS = 'user-minus';
export const USER_PLUS = 'user-plus';
export const USER_X = 'user-x';
export const USER = 'user';
export const USERS = 'users';
export const VIDEO_OFF = 'video-off';
export const VIDEO = 'video';
export const VOICEMAIL = 'voicemail';
export const VOLUME_1 = 'volume-1';
export const VOLUME_2 = 'volume-2';
export const VOLUME_X = 'volume-x';
export const VOLUME = 'volume';
export const WATCH = 'watch';
export const WIFI_OFF = 'wifi-off';
export const WIFI = 'wifi';
export const WIND = 'wind';
export const X_CIRCLE = 'x-circle';
export const X_OCTAGON = 'x-octagon';
export const X_SQUARE = 'x-square';
export const X = 'x';
export const YOUTUBE = 'youtube';
export const ZAP_OFF = 'zap-off';
export const ZAP = 'zap';
export const ZOOM_IN = 'zoom-in';
export const ZOOM_OUT = 'zoom-out';
